module.exports = __webpack_public_path__ + "assets/img/6_521_big.eb13cad8.jpg";